import { Input } from '@nike/frame-component-library';
import PropTypes from 'prop-types';
import React from 'react';

import { CustomPanel } from '../../../reusable';

/* display form contents if adding (no form validation here)
 */
const calculateIsOpen = (properties) => (properties.adding);

class FacilityDimensions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: calculateIsOpen(props),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.formErrors !== this.props.formErrors) {
      if (this.state.isOpen) { return; }
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ isOpen: calculateIsOpen(this.props) });
    }
  }

  panelToggle = () => this.setState((prevState) => ({ isOpen: !prevState.isOpen }));

  render = () => (
    <CustomPanel
      isOpen={this.state.isOpen}
      label="Facility Dimensions"
      onClick={this.panelToggle}
    >
      <article className="ncss-col-sm-4 va-sm-t">
        <Input
          isDisabled={this.props.userIsReadOnly}
          label="Total Area"
          type="number"
          value={this.props.formData.facilityDimensions?.totalArea || ''}
          onChange={({ target: { value } }) => this.props.updateFacilityDimensions('totalArea', value)}
        />
      </article>
      <article className="ncss-col-sm-4 va-sm-t">
        <Input
          isDisabled={this.props.userIsReadOnly}
          label="Total Storage Area"
          type="number"
          value={this.props.formData.facilityDimensions?.totalStorageArea || ''}
          onChange={({ target: { value } }) => this.props.updateFacilityDimensions('totalStorageArea', value)}
        />
      </article>
      <article className="ncss-col-sm-4 va-sm-t">
        <Input
          isDisabled={this.props.userIsReadOnly}
          label="Measurement Units"
          value={this.props.formData.facilityDimensions?.measurementUnits || ''}
          onChange={({ target: { value } }) => this.props.updateFacilityDimensions('measurementUnits', value)}
        />
      </article>
    </CustomPanel>
  );
}

FacilityDimensions.propTypes = {
  // ignoring eslint even though the prop is used
  // eslint-disable-next-line react/no-unused-prop-types
  adding: PropTypes.bool.isRequired,
  formData: PropTypes.shape().isRequired,
  formErrors: PropTypes.shape().isRequired,
  updateFacilityDimensions: PropTypes.func.isRequired,
  userIsReadOnly: PropTypes.bool.isRequired,
};

export default FacilityDimensions;
